// @flow
import type {IStatus} from './imports/ITest'

function fn(sA: ISource<A>, saf: IStatus<A | B>) {}
